import axios from "axios";
import {axiosAuthHeader} from "config/axiosConfig";
import api from "../api";

export const bookCall = async (bookData: any) => {
    return api.post(`/book-call`, {...bookData}, axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch((e) =>{
            return e;
        })
}

export const getFeeList = async () => {
    return api.get(`/fee-list`, axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch((e) =>{
            return e;
        })
}

export const getCallDatesList = async () => {
    return api.get(`/call-slots`,axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}


export const getUserCallList = async () => {
    return api.get(`/call-list`,axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}


export const deleteUserCall = async (callId: number) => {
    const authheaders = axiosAuthHeader();
    return api.delete(`/call/${callId}`,{
        headers:{...authheaders.headers}
    })
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}
